import { createOnlyMineFilter } from '@ayocore/erp/crm/client/components/filters';
import type { PartnerRepository } from '@ayocore/erp/crm/server/repositories/PartnerRepository';

/**
 * Фильтр «Мои / Все» для списка партнёров.
 * Привязка: partner.manager_id = текущий пользователь.
 */
export const FilterByOnlyMine = createOnlyMineFilter<PartnerRepository>({
  key: 'onlyMine',
  applyMine: (repo, userId) => repo.where('manager_id', userId),
  logLabel: 'Partner FilterByOnlyMine',
});
